module.exports = __webpack_public_path__ + "static/media/gc-sunset-oia.5aee2a71.png";